import Form from './Form';
import List from '../Client/List';
import Cart from '../Client/Cart';
import PostOffice from './PostOffice';

const Components = {
    Form : Form,
    List : List,
    Cart : Cart,
    PostOffice
}

export default Components;